/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectDto } from '../../models/backend-project-dto';

export interface ProjectsProjectsRetrieve$Params {
  id: number;
}

export function projectsProjectsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectDto>;
    }),
  );
}

projectsProjectsRetrieve.PATH = '/api/projects/projects/{id}/';
